export function escapeHTML(value: unknown): string {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

export function shortValue(value: string, size = 8): string {
  if (value.length <= size * 2 + 3) return value;
  return `${value.slice(0, size)}…${value.slice(-size)}`;
}

export function formatUSDC(atomic: string): string {
  const normalized = (atomic || "0").replace(/^0+(?=\d)/, "");
  const padded = normalized.padStart(7, "0");
  const integer = padded.slice(0, -6);
  const fraction = padded.slice(-6).replace(/0+$/, "");
  return fraction ? `${integer}.${fraction}` : integer;
}

export function usdcToAtomic(value: string): string {
  const normalized = value.trim();
  if (!/^\d+(?:\.\d{1,6})?$/.test(normalized)) {
    throw new Error("USDC 金额最多支持 6 位小数");
  }
  const [integer, fraction = ""] = normalized.split(".");
  return (BigInt(integer) * 1_000_000n + BigInt(fraction.padEnd(6, "0"))).toString();
}

export function parseJSON(value: string, kind: "array" | "object", label: string): unknown {
  let parsed: unknown;
  try {
    parsed = JSON.parse(value);
  } catch {
    throw new Error(`${label} 不是合法 JSON`);
  }
  const valid = kind === "array"
    ? Array.isArray(parsed)
    : typeof parsed === "object" && parsed !== null && !Array.isArray(parsed);
  if (!valid) throw new Error(`${label} 必须是 JSON ${kind === "array" ? "数组" : "对象"}`);
  return parsed;
}

export function showStatus(id: string, message: string, error = false): void {
  const element = document.querySelector<HTMLElement>(`#${id}`)!;
  element.hidden = false;
  element.className = `form-status ${error ? "error" : ""}`;
  element.textContent = message;
}
